import React, { Component } from 'react';
import './App.css';

import { ConnectedRouter } from "react-router-redux";
import { withStyles } from '@material-ui/core/styles';
import  Routes  from './routes'
console.log('ConnectedRouter', ConnectedRouter)
const styles = {

}

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false
        };
    }
    

    onOpen(open) {
        this.setState({ open: open })
    }

    render() {

        const classes = this.props.classes;
        const { open } = this.state
        console.log('this.props.history', this.props.history)
        return (
            <ConnectedRouter history={this.props.history}>
            <div style={{width: '100%',
        zIndex: 1,
        overflow: 'hidden',}}>
                <div style={{
        position: 'relative',
        display: 'flex',
        fallbacks: [
            { display: '-webkit-box' },
            { display: '-moz-box' },
            { display: '-ms-flexbox' },
            { display: '-webkit-flex' }
          ],
        width: '100%',
        minHeight: '100vh',
    }}>
                   
                            <main style={{
        width: '100%',
        flexGrow: 1,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
        //marginTop: 71,
    }}>
   
                               <Routes/>
                                
                            </main>
                            </div>
                            </div>
                     
              
            </ConnectedRouter>
        );
    }
}

export default withStyles(styles)(App);


